import React from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { rtdb, db } from '../../config/firebase'
import { Autosave, useAutosave } from 'react-autosave';
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import { Context } from '../../App';

import Spinner from '../../components/Loading/TailSpin';
import ReactGA from "react-ga4";
import DocsEditor from './Editor';
import UserNotes from './FilesAndFolders';
import { LuCheckCircle } from "react-icons/lu";
import dayjs from 'dayjs';
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';
import { FaCheck } from "react-icons/fa";
import { PiPaperPlaneRightFill } from "react-icons/pi";

import { CiFloppyDisk } from 'react-icons/ci';

function Notes() {
  const navigate = useNavigate();
  const location = useLocation();
  const newFileNameRef = useRef(null);
  const quillEditorRef = useRef(null);

  const { fileIdContext, quillDocsContext, showUsersContext, fileNameContext, filesListContext, folderDetailsContext } = useContext(Context);

  const [fileId, setFileId] = fileIdContext;
  const [fileName, setFileName] = fileNameContext;
  const [showUsers, setShowUsers] = showUsersContext;

  const [quillDocsValue, setQuillDocsValue] = quillDocsContext
  const [filesList, setFilesList] = filesListContext;
  const [currFolder, setCurrFolder] = folderDetailsContext;

  const [isLoading, setIsLoading] = useState(false);
  const noteId = location.pathname.split("/")[2] ? location.pathname.split("/")[2] : "";

  const [foldersList, setFoldersList] = useState([]);

  const [savedStatus, setSavedStatus] = useState(0); // 0 Unsaved, 1 Not Edited, 2 Saved
  const [isEditing, setIsEditing] = useState(false);
  const [newFileName, setNewFileName] = useState(fileName);

  const [showConfirmationPop, setShowConfirmationPopup] = useState(false);
  // useOutsideCloser(confirmationRef, setShowConfirmationPopup);

  useOutsideCloser(newFileNameRef, (val) => { setIsEditing(val) });
  // useOutsideCloser(quillEditorRef, () => { if (savedStatus === 1) setShowConfirmationPopup(true); });


  const saveToLocalStorage = async ([quillDocsValue, fileId]) => {

    localStorage.setItem(fileId, JSON.stringify(
      {
        createdAt: dayjs().format(),
        notes: quillDocsValue,
      }));
  }
  useAutosave({ data: [quillDocsValue, fileId], onSave: saveToLocalStorage, interval: 2000 })

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Chatting" })

    ReactGA.event({
      category: "Group",
      action: "Accessed Notes",
      label: localStorage.getItem("displayName"),
      value: noteId,
    });
  }, []);

  useEffect(() => {
    setSavedStatus(0);
    setNewFileName(fileName)

  }, [fileId])


  const handleUpdateDoc = async () => {

    // console.log(fileId, quillDocsValue);
    const docRef = doc(db, 'notes', fileId);
    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          createdAt: dayjs().format(),
          notes: quillDocsValue,
        });
        console.log("Document successfully Edited: ",);
        setSavedStatus(2);
      } else {
        console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };

  const handleNotesKeyDown = (e) => {
    // console.log(e);
    setSavedStatus(1);
    if (e.key === 's' && (navigator.userAgent.includes('Mac') ? e.metaKey : e.ctrlKey)) {
      e.preventDefault();
      handleUpdateDoc();
    }
  }

  const handleRenameFile = async () => {
    //-------------------------------------------------- console.log(fileId, quillDocsValue);
    try {

      const folderDocRef = doc(db, 'notesFolders', currFolder.id);
      const folderDocSnap = await getDoc(folderDocRef);

      if (folderDocSnap.exists()) {
        let allFiles = folderDocSnap.data().files;

        allFiles = allFiles.map((item) => {
          if (item.id === fileId) return ({ ...item, createdAt: dayjs().format(), name: newFileName })
          else return item
        })

        await updateDoc(folderDocRef, {
          files: allFiles
        });

        const docRef = doc(db, 'notes', fileId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          await updateDoc(docRef, {
            createdAt: dayjs().format(),
            name: newFileName,
          });
          // console.log("Document successfully Renamed: ",);
          setFilesList(allFiles)
          setFileName(newFileName);
        } else {
          console.log("DNE: ",);
        }

      } else {
        console.log("DNE: ", currFolder.id);
      }


    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };

  const handleRenameKeyDown = (e) => {
    // console.log(e);
    if (e.key === 'Enter' && newFileName !== "") {
      // console.log("SUBMIT");
      setIsEditing(false);
      handleRenameFile();
    }

    if (e.key === 'Escape') {
      // console.log("SUBMIT");
      setIsEditing(false);
    }
  }


  if (!isLoading)
    return (
      <div className='relative w-full h-full flex justify-between'>
        <UserNotes folderData={[foldersList, setFoldersList]} />

        {fileName !== "" &&
          <div onClick={() => { setIsEditing(true) }} ref={newFileNameRef}
            className="absolute left-0 right-0 top-0 mx-auto w-fit border px-2 md:px-5 pt-1 md:pt-2 pb-1 md:pb-1.5 bg-white text-lg md:text-xl font-semibold text-headPrimary rounded-b-xl shadow-md border-l border-b border-r z-20 ">
            {isEditing ?
              <div className='relative'>
                <input
                  value={newFileName}
                  onKeyDown={handleRenameKeyDown}
                  onChange={(e) => { setNewFileName(e.target.value) }}
                  className="py-0.5 px-2.5 pr-6 w-full text-base text-headPrimary bg-white rounded-lg border border-gray-300 focus:ring-headPrimary focus:border-headPrimary dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-headPrimary dark:focus:border-headPrimary" placeholder="File Name"></input>

                <PiPaperPlaneRightFill
                  onClick={() => {
                    if (newFileName !== "") {
                      setIsEditing(false);
                      handleRenameFile();
                    }
                  }}
                  className="absolute top-0 bottom-0 my-auto right-1.5 cursor-pointer text-headPrimary hover:text-our-600  h-4 w-4" />
              </div>

              :
              <div className="px-5">{fileName}</div>
            }
          </div>}


        {fileId !== "" ?
          <div ref={quillEditorRef} className='relative w-full h-full overflow-hidden'>
            {/* <div className=""></div> */}
            <div onClick={handleUpdateDoc} className="absolute top-[14px] left-6 text-white z-20 cursor-pointer">
              <CiFloppyDisk className='h-5 w-5 text-[#444] hover:text-headPrimary' />
              <div className={`rounded-full h-1.5 w-1.5 ${savedStatus === 2 ? "bg-green-500" : savedStatus === 1 ? "bg-red-600" : "bg-gray-400"} absolute -top-0.5 -right-0.5`}></div>
            </div>

            <div className="w-full h-[47px] bg-lightPrimary "></div>

            <div className="w-full h-[calc(100%-48px)] flex justify-center bg-[#fcfafdbf] border-l ">
              <DocsEditor key={noteId} handleNotesKeyDown={handleNotesKeyDown} />
            </div>
          </div>
          :

          <div className="w-full flex justify-center bg-[#fcfafdbf] border-l items-center">
            <div
              onClick={() => { setShowUsers(true) }}
              className="text-lg font-normal text-[#91edb8] hover:text-headPrimary cursor-pointer">
              Click here to Open a Note</div>
          </div>
        }
        {/* <MediaUploads /> */}


        {showConfirmationPop &&
          <div style={{ "backgroundColor": "rgba(0, 0, 0, 0.45)" }}
            className="fixed inset-0 z-50 flex items-center justify-center outline-none focus:outline-none">
            <div className="wholeFadeIn relative my-6 mx-auto w-fit">
              <div className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">


                <div className="rounded-full bg-[#5ec393] w-12 h-12 p-2.5">
                  <FaCheck className='h-full w-full ' />
                </div>

                <div className="text-xl font-bold text-center mt-4">
                  Save the Changes
                </div>

                <div className="text-base text-center text-gray-700 mt-1">
                  Do you want to save the changes you made to {fileName} ?
                </div>

                <button
                  onClick={() => { handleUpdateDoc(); setShowConfirmationPopup(false) }}
                  className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
                  SAVE
                </button>
              </div>
            </div>
          </div>}

      </div>
    )

  else return (<Spinner />)
}

export default Notes